import { getPusher } from "../pusher";

// Must match SeV2AttachmentProcessedClientEvent.NAME on the BFF.
const ATTACHMENT_PROCESSED_EVENT = "sev2-attachment-processed";

// A missed signal (dropped socket) must not block send forever; give up so the upload can be marked failed and retried.
const RESOLVE_DEADLINE_MS = 60_000;

/**
 * Resolves an upload's documentId off the BFF's attachment-processed signal, then an access-checked fetch — the app's
 * realtime pattern (see useDocumentsUploader). The channel is shared with it, so this unbinds only its own handler.
 */
export const waitForUploadedDocumentId = (
  channelId: string,
  uploadId: string,
  fetchDocumentId: (uploadId: string) => Promise<string | null>,
): Promise<string | null> =>
  new Promise((resolve) => {
    const channel = getPusher().subscribe(channelId);
    let settled = false;

    const finish = (documentId: string | null) => {
      if (settled) return;
      settled = true;
      clearTimeout(deadline);
      channel.unbind(ATTACHMENT_PROCESSED_EVENT, onSignal);
      resolve(documentId);
    };

    const onSignal = async () => {
      const documentId = await fetchDocumentId(uploadId);
      if (documentId) finish(documentId);
    };

    const deadline = setTimeout(() => finish(null), RESOLVE_DEADLINE_MS);
    channel.bind(ATTACHMENT_PROCESSED_EVENT, onSignal);
    // Cover an upload already processed before we subscribed (e.g. a retry).
    void onSignal();
  });
